import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { BrowserView, MobileView } from "react-device-detect";
import { Trans } from "react-i18next";
import ReactPaginate from "react-paginate";
import "../styles/components/Pagination.scss";

interface paginate {
  pageCount: number;
  onPageChange: any;
  totalResultsFound?: number;
  pageNumber?: any;
  totalRecords?: number;
}

const Pagination = (props: paginate) => {
  const [paginationPerPage, setPaginationPerPage] = useState(5);
  const handlePageClick = (e: any) => {
    if (e.selected == undefined || e.selected >= 3) {
      setPaginationPerPage(props.pageCount);
    }
    if (e.selected < 3) {
      setPaginationPerPage(5);
    }
    props.onPageChange(e);
  };

  const patientDisplay = props?.pageNumber * 10;

  return (
    <div className="pagination">
      <BrowserView>
        <Row className="grid-container">
          <Col className="verticalAlignItems">
            <p className="paginationSummary">
              <Trans i18nKey={"pagination_summary"}></Trans>{" "}
              {props.pageNumber === 1 ? 1 : patientDisplay - 9} -{" "}
              {props.pageNumber
                ? props.pageCount === props.pageNumber
                  ? props.totalResultsFound
                  : patientDisplay
                : 10}{" "}
              <Trans i18nKey={"pagination_summary_of"}></Trans>{" "}
              {props.totalResultsFound}{" "}
            </p>
          </Col>
          <Col>
            <ReactPaginate
              className="text-end"
              forcePage={props.pageNumber - 1}
              breakLabel="..."
              nextLabel=""
              nextClassName="next-custom"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={
                props.pageCount < 5 ? props.pageCount : paginationPerPage
              }
              previousLabel=""
              previousClassName="prev-custom"
              marginPagesDisplayed={0}
              disabledLinkClassName="disabledLink"
            />
          </Col>
        </Row>
      </BrowserView>
      <MobileView>
        <ReactPaginate
          forcePage={props.pageNumber - 1}
          className="text-end"
          breakLabel="..."
          nextLabel=""
          nextClassName="next-custom"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={props.pageCount < 5 ? props.pageCount : paginationPerPage}
          previousLabel=""
          previousClassName="prev-custom"
          marginPagesDisplayed={0}
          disabledLinkClassName="disabledLink"
        />
      </MobileView>
    </div>
  );
};

export default Pagination;
